import { getAppToken, useAppURL, useConfig, useExtensions } from 'api'
import { useEffect, useRef, useState } from 'react'
import { getShopId, nanoId, showMessage } from 'utils'
import { AppExtension, Appointment, Config } from 'types'
import { VerticalContainer } from 'components/styled'
import { AppTarget, Appointment as AppAppointment, AdminHostAppointmentDetailsInfo } from '@sesamiapp/app-message'

type ExtensionLoaderProps = {
    appointment: Appointment
}

export const AppointmentDetailsInfoExtensionLoader = ({ appointment }: ExtensionLoaderProps) => {

    //hooks:
    const { data: config } = useConfig()

    //api:
    const { data: extensions } = useExtensions([AppTarget.ADMIN_APPOINTMENT_DETAILS_INFO], 15)

    return (config && extensions && extensions.length) ? (
        <VerticalContainer style={{ gap: 0 }}>
            {extensions.map(extension => (
                <AppointmentDetailsExtensionLoaderContent
                    key={extension.id}
                    appId="blah" //tmp
                    extension={extension}
                    appointment={appointment}
                    config={config}
                />
            ))}
        </VerticalContainer>
    ) : null

}

type ExtensionLoaderContentProps = {
    appId: string
    extension: AppExtension
    appointment: Appointment
    config: Config
}

const AppointmentDetailsExtensionLoaderContent = ({ appId, extension, appointment, config }: ExtensionLoaderContentProps) => {

    //hooks:
    const iframe = useRef<HTMLIFrameElement>(null)

    //state:
    const [ timestamp ] = useState((new Date()).getTime())
    const [ messageId ] = useState(nanoId([appId, timestamp, config.locale], 8))
    const [ client, setClient ] = useState<AdminHostAppointmentDetailsInfo | null>(null)
    const [ height, setHeight ] = useState(300)

    //api:
    const { data: url } = useAppURL(
        appId,
        null,
        AppTarget.ADMIN_APP_LOADER_MAIN,
        timestamp,
        messageId,
        config.locale,
        null
    )

    //startup:
    useEffect(() => {
        if(iframe.current && !client){
            const cl = new AdminHostAppointmentDetailsInfo({
                timestamp,
                messageId,
                shopId: getShopId() ?? '',
                locale: config.locale,
                extra: { appointment: getAppAppointment(appointment) },
                getToken,
                setHeight: (height: number) => setHeight(height),
                onNotification: showMessage
            })
            setClient(cl)
        }
    }, [iframe])

    const getToken = async () => {
        const response: any = await getAppToken(extension.id)
        try{
            const token = response.data.json.data.getAppToken.token
            return token
        }catch(e){e}
        return null
    }

    return (
        <iframe
            ref={iframe}
            src={(client && url) ? url : undefined}
            style={{
                height: height,
                border: 'none'
            }}
        />
    )
}

const getAppAppointment = (appointment: Appointment): AppAppointment => ({
    id: appointment.id,
    datetime: appointment.datetime,
    
    serviceId: appointment.service?.id ?? null,
    variantId: appointment.externalVariantId,
    duration: appointment.duration,
    quantity: appointment.quantity,

    resources: getAppResources(appointment),
    orderId: appointment.orderId,
    orderName: appointment.orderName,
    price: appointment.price,
    currency: appointment.currency
})

const getAppResources = (appointment: Appointment) => {
    if(appointment.teamMember){
        return [{
            id: appointment.teamMember.id,
            name: appointment.teamMember.name,
            image: appointment.teamMember.image.path,
            description: appointment.teamMember.description,
        }]
    }else{
        return []
    }
}
